var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardMedia = void 0;
var CardMedia_1 = __importDefault(require("./CardMedia"));
exports.CardMedia = CardMedia_1.default;
exports.default = CardMedia_1.default;
//# sourceMappingURL=index.js.map